import script from "./YearCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./YearCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./YearCalendar.vue?vue&type=style&index=0&id=54b8ae72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b8ae72"]])

export default __exports__